import { CloudFinishInstallationInputSchema } from '@uv/machine'
import { mightFail } from 'might-fail'
import { fetchWithAuth } from '../auth/fetch-with-auth'
import { useDataStore } from '../machine/use-data-store'
import { useDataStoreLocalStorage } from '../machine/use-data-store-local-storage'

const CLOUD_SYNC_API_URL = import.meta.env.VITE_CLOUD_SYNC_API_URL
if (!CLOUD_SYNC_API_URL) throw new Error('CLOUD_SYNC_API_URL is not defined')

let syncing = false

export const syncPendingInstallationFinishes = async () => {
  if (syncing || useDataStore.getState().mockMode) return
  if (!useDataStoreLocalStorage.getState().user.isAuthenticated) return

  syncing = true
  try {
    const records = useDataStoreLocalStorage.getState().localInstallationRecords
    // Legacy records have no delivery flag and must not be replayed automatically.
    for (const pending of records.filter(record => record.finishPending)) {
      if (!useDataStoreLocalStorage.getState().user.isAuthenticated) break
      const parsed = CloudFinishInstallationInputSchema.safeParse(pending)
      if (!parsed.success) {
        console.error('Invalid pending installation finish', parsed.error)
        continue
      }

      const { error, result } = await mightFail(
        fetchWithAuth(`${CLOUD_SYNC_API_URL}/installation/finish`, {
          method: 'POST',
          body: JSON.stringify(parsed.data),
          timeout: 2000
        })
      )
      if (error || result.error || !result.result.ok) {
        console.error('Cloud finish installation error:', error ?? result?.error)
        continue
      }

      useDataStoreLocalStorage.getState().acknowledgeInstallationFinish(parsed.data.id)
    }
  } finally {
    syncing = false
  }
}
